import { render, staticRenderFns } from "./VideoHistoryListV2.vue?vue&type=template&id=e6f4fb20&"
import script from "./VideoHistoryListV2.vue?vue&type=script&lang=js&"
export * from "./VideoHistoryListV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports